import { memo } from 'react';
import { XBoldIcon } from '@/icons';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { cn } from '@/utils/tailwind.util';
import { useEditMode } from '../../focus/useIsEditMode';
import { QuizImage } from '../QuizImage';
export const MultipleOptionImage = memo(({
  imageUrl,
  isUploading,
  onRemove,
  className
}: {
  imageUrl: string;
  isUploading: boolean;
  onRemove?: () => void;
  className?: string;
}) => {
  const {
    isEditMode
  } = useEditMode();
  if (isUploading) {
    return <Container className={className}>
          <QuizImage.Loading className="size-full" />
        </Container>;
  }
  return <Container className={className}>
        <QuizImage.Container className="size-full" onClick={() => {
      imageDetailModal.open(imageUrl);
    }}>
          <QuizImage.Thumbnail src={imageUrl} alt="multiple-option-image" />
        </QuizImage.Container>
        {isEditMode && onRemove && <QuizImage.RemoveButton className="shadow-xs" onClick={onRemove}>
            <XBoldIcon width={14} height={14} className="[&>*]:fill-white" />
          </QuizImage.RemoveButton>}
      </Container>;
});
const Container = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('relative mb-sm ml-[39px] size-[62px]', className)} data-sentry-component="Container" data-sentry-source-file="MultipleOptionImage.tsx">
      {children}
    </div>;
};